'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';
import { colors } from '../../Utils/constants.js';
import useFormItemContext from './Item/context.js';
import { HIDDEN_MSG } from '../constant.js';

var ErrorMsg = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 12px;\n    color: ", ";\n    margin-top: 4px;\n"], ["\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 12px;\n    color: ", ";\n    margin-top: 4px;\n"])), colors.dangerColor);
function FormError(_a) {
    var disable = _a.disable, forceMsg = _a.forceMsg;
    var errorMsg = useFormItemContext().errorMsg;
    if (forceMsg && forceMsg !== '') {
        return React__default.createElement(ErrorMsg, null, forceMsg);
    }
    return !disable && errorMsg !== '' && errorMsg !== HIDDEN_MSG ? React__default.createElement(ErrorMsg, null, errorMsg) : null;
}
var templateObject_1;

export { FormError as default };
//# sourceMappingURL=Error.js.map
